export default __webpack_public_path__ + "static/media/example5.715f989b.svg";